// extracted by mini-css-extract-plugin
export default {"container":"EVu3r_d_Wg3U6OkoPWxP","body":"gH7o_M4P0U2umFF8UEKz","footer":"cl9WayDlsbfbkgm_u9bU","logo":"oABrmjNtsUrBm5MjRJ3O","title":"dOF8BZ79l_JbPPKev4Gl"};